export default __webpack_public_path__ + "images/GRENADINE.3625159.png";